var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.test.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-vials icon"}),_vm._v("Test Connection")])])}
var staticRenderFns = []

export { render, staticRenderFns }